import { useState } from 'react';

import { ActionIcon, Code, Group, Text } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';

interface GeneratedJinjaPanelProps {
  source: string;
}

export function GeneratedJinjaPanel({ source }: Readonly<GeneratedJinjaPanelProps>) {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div style={{ borderTop: '1px solid var(--mantine-color-default-border)' }}>
      <Group
        gap="xs"
        px="sm"
        py={6}
        justify="space-between"
        style={{ background: 'var(--mantine-color-default-hover)', cursor: 'pointer' }}
        onClick={() => setCollapsed((c) => !c)}
      >
        <Text size="xs" fw={600} c="dimmed" tt="uppercase">
          Generated Jinja
        </Text>
        <ActionIcon size="xs" variant="subtle" aria-label={collapsed ? 'Expand' : 'Collapse'}>
          {collapsed ? <IconChevronUp size={14} /> : <IconChevronDown size={14} />}
        </ActionIcon>
      </Group>
      {!collapsed && (
        <Code
          block
          style={{
            maxHeight: 180,
            overflow: 'auto',
            fontSize: 12,
            margin: 0,
            borderRadius: 0,
          }}
        >
          {source || '(empty)'}
        </Code>
      )}
    </div>
  );
}
